import { useDisclosure } from '@chakra-ui/react';
import { IQuoteRespSchema } from '@monetize/types/app';
import { Maybe } from '@monetize/types/common';

export interface OpportunityLinkDataTypes {
  isOpen: boolean;
  quote?: Maybe<IQuoteRespSchema>;
  onOpen: () => void;
  onClose: () => void;
  /** Fetch quote */
  loadData?: Maybe<() => void>;
}

export const useOpportunityLinkData = ({
  quote,
  loadData,
}: {
  quote?: Maybe<IQuoteRespSchema>;
  loadData?: Maybe<() => void>;
} = {}): OpportunityLinkDataTypes => {
  const { open: isOpen, onOpen, onClose } = useDisclosure();

  return {
    isOpen,
    quote,
    loadData,
    onOpen,
    onClose,
  };
};
